import React from 'react';
import { FaCheckCircle, FaExclamationCircle, FaInfoCircle } from 'react-icons/fa';
import './Toast.css';

export function ToastItem({ message, type, onDismiss }) {
  const icons = {
    success: <FaCheckCircle className="toast-icon" />,
    error: <FaExclamationCircle className="toast-icon" />,
    info: <FaInfoCircle className="toast-icon" />,
  };
  return (
    <div className={`toast toast-${type}`} role="alert">
      {icons[type] || icons.info}
      <span className="toast-message">{message}</span>
      {onDismiss && (
        <button type="button" className="toast-dismiss" onClick={onDismiss} aria-label="Dismiss">
          ×
        </button>
      )}
    </div>
  );
}

export default function ToastContainer({ toasts }) {
  return (
    <div className="toast-container" aria-live="polite">
      {toasts.map((t) => (
        <ToastItem key={t.id} message={t.message} type={t.type} />
      ))}
    </div>
  );
}
